import React, { useEffect,useState } from 'react'
import Slider from 'react-slick'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {setting} from "../../Common/setting"
import "./Categories.css"
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function Categories() {

  setting.dots=true;
  const navigate = useNavigate();

  const allCategories = useSelector(state => state.Books.categories)
  

  const [data,setData]=useState( [
  {name:'medical',books:'0'},
  {name:'magazines',books:'0'},
  {name:'school books',books:'0'},
  {name:'competitive exam',books:'0'},
  {name:'fiction',books:'0'}
  ]);

  const fetchData=()=>{

    console.log("all categories : ",allCategories)
    data.map((ele)=>{
      allCategories.map((cat)=>{
        if(ele.name===cat.name)
        {
          console.log('data ele : ',ele.name)
          setData([...data,{name:ele.name,books:cat.ads.length}])
        }
      })
    })

    
  }
  
  useEffect(() => {
    
   
    fetchData();
  }, [])
  

  return (
    <div className='Categories'>
      <div className="categoriesHeader">
        <h3>Book Categories</h3>
        <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Aut corrupti unde voluptas quod harum accusantium officiis quaerat omnis. Dicta dolores quae dignissimos mollitia cum nostrum omnis quia et harum ducimus.</p>
      </ div>
      <Slider {...setting}>

        <div className='Category green'>
          <i className="fa-solid fa-book fa-2x" />
          <h2>{data[0].name.charAt(0).toUpperCase()+data[0].name.slice(1)}</h2>
          <p>{data[0].books} <strong>Ads</strong></p>
          <p>Homeopathy , MBBS , Medicine , Nursing</p>
          <button className='categoryBtn' onClick={()=>navigate(`/search-result/:/:medical/:/:`)}>View All</button>          
        </div>
            
        <div className='Category pink'>
          <i className="fa-solid fa-book fa-2x" />
          <h2>{data[1].name.charAt(0).toUpperCase()+data[1].name.slice(1)}</h2>
          <p>{data[1].books} <strong>Ads</strong></p>
          <p >Automobile , Bollywood / Hollywood , Business , Computer, Education , Entertainment , Fashion ,etc</p>
          <button className='categoryBtn' onClick={()=>navigate(`/search-result/:/:magazines/:/:`)}>View All</button>          
        </div>
            
        <div className='Category blue'>
          <i className="fa-solid fa-book fa-2x" />
          <h2>{data[2].name.charAt(0).toUpperCase()+data[2].name.slice(1)}</h2>
          <p>{data[2].books} <strong>Ads</strong></p>
          <p>Arts , Commerce ,Science and others</p>
          <button className='categoryBtn' onClick={()=>navigate(`/search-result/:/:school books/:/:`)}>View All</button>          
        </div>
            
        <div className='Category purp'>
          <i className="fa-solid fa-book fa-2x" />
          <h2>{data[3].name.charAt(0).toUpperCase()+data[3].name.slice(1)}</h2>
          <p>{data[3].books} <strong>Ads</strong></p>
          <p>CAT|GATE|GRE , Engineering Exams , IBPS PO, Management Exams , Medical Exams , etc</p>
          <button className='categoryBtn' onClick={()=>navigate('/search-result/:/:competitive exam/:/:')}>View All</button>          
        </div>
            
        <div className='Category yellow' >
          <i className="fa-solid fa-book fa-2x" />
          <h2>{data[4].name.charAt(0).toUpperCase()+data[4].name.slice(1)}</h2>
          <p>{data[4].books} <strong>Ads</strong></p>
          <p>Comics , Fiction , Non-Fiction , Poetry , etc</p>
          <button className='categoryBtn' onClick={()=>navigate(`/search-result/:/:fiction/:/:`)}>View All</button>          
        </div>
        
      </Slider> 
    </div>
  )
}
